import React, { useState } from 'react';
import c from './analytics.module.scss';
import { Toggle } from '@monash/portal-react';

const Analytics = () => {
  const reports = [
    {
      value: 'EDMUND',
      url: 'https://lookerstudio.google.com/embed/reporting/f81a1f50-9237-4745-9fcc-b6f242f11cc6/page/k11UF',
    },
    {
      value: 'JIAZHE LINKS',
      url: 'https://lookerstudio.google.com/embed/reporting/5b84c8e2-41a0-499d-8bc7-64ad13a15669/page/p_ehtbmu69vd',
    },
    {
      value: 'JIAZHE HOME',
      url: 'https://lookerstudio.google.com/embed/reporting/fe0d7a4d-2320-478c-b19d-00b3fdf4d41f/page/a5RZF',
    },
  ];

  const [selectedReport, setSelectedReport] = useState(reports[0]);

  return (
    <div className={c.analyticsContainer}>
      <div className={c.toggleContainer}>
        <Toggle
          options={reports}
          selected={selectedReport}
          setSelected={setSelectedReport}
        />
      </div>
      <iframe
        title={selectedReport.value}
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        src={selectedReport.url}
      />
    </div>
  );
};

export default Analytics;
